import React, { useReducer, useState,useEffect } from "react";
import "./plan.component.scss";
import SelectPlan from "./select-plan/select-plan.component";
import KnowMore from "./know-more/know-more.component";
import {
  DEFAULT_1_MONTH_PLAN,
  SELECT_POP_UP,
  KNOW_MORE_POP_UP,
  CAROUSEL_RESPONSIVE_CONSTANTS,
} from "../../../common/constants/constants";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Card from "../plan/card/card.component";
import {fireAnalyticsOnSelectPlanButtonClick, fireAnalyticsOnPlanDurationButtonClick} from '../../../../common/services/analytics'
const initailPopUpDetail = {
  plan: {},
  popUpType: null,
};

const plan = { code: "" };

const popUpReducer = (state, popUpDetail) => {
  switch (popUpDetail.popUp) {
    case SELECT_POP_UP:
      return { plan: popUpDetail.plan, popUpType: SELECT_POP_UP };
    case KNOW_MORE_POP_UP:
      return { plan: popUpDetail.plan, popUpType: KNOW_MORE_POP_UP };
    default:
      return initailPopUpDetail;
  }
};
let document=window && window.document &&  window.document.body;
const Plan = (props) => {
  const { plans, setSelectedPlan, isProductPage, existingPlanDetails, setCallPlanDetails } = props;

  const [selectedPlan, setPlan] = useState(plan);
  const [updatedPlans, setUpdatedPlans] = useState(plans);
  const [planIndex, setPlanIndex] = useState(0);
  const [popUpDetail, setPopUpDetails] = useReducer(
    popUpReducer,
    initailPopUpDetail
  );
  useEffect(() => {
    if(!isProductPage){
      let upadtePlan= updatedPlans;
      upadtePlan = moveArrayItem(plans, planIndex, 0);
      setUpdatedPlans(upadtePlan)
    }
  },[planIndex] );
  const togglePopUp = (popUpDetail) => {
    if(popUpDetail && popUpDetail.popUp){
      if (document) {
        var orig = document.className;
        document.className = orig + (orig ? ' ' : '') + 'no-scroll';
      }
    } else {
      if (document) {
        document.className = document.className.replace(/ ?no-scroll/, '');
      }
    }
    if(popUpDetail && popUpDetail.plan){
      fireAnalyticsOnSelectPlanButtonClick(popUpDetail.plan)
    }
    setPopUpDetails(popUpDetail);
  };

  if (
    plans &&
    plans.length > 0 &&
    selectedPlan &&
    selectedPlan.code === "" &&
    existingPlanDetails &&
    existingPlanDetails !== ""
  ) {
    plans.map((plan, index) => {
      if (existingPlanDetails.planDetail.code === plan.code) {
        plan.choosedARP = existingPlanDetails.planDetail.choosedARP;
        setPlan(plan);
        setSelectedPlan(plan);
        setPlanIndex(index)
      }
    });
  }

  const choosePlan = (plan, choosedARP) => {
    plan.choosedARP = choosedARP;
    fireAnalyticsOnPlanDurationButtonClick(plan)
    setPlan(plan);
    setPopUpDetails(initailPopUpDetail);
    setSelectedPlan(plan);
    setCallPlanDetails(true)
    if (document) {
      document.className = document.className.replace(/ ?no-scroll/, '');
    }
  };
  const moveArrayItem = (array, fromIndex, toIndex) => {
    const arr = [...array];
    arr.splice(toIndex, 0, ...arr.splice(fromIndex, 1));
    return arr;
  }
  const renderCards = () =>
      updatedPlans &&
      updatedPlans.length > 0 &&
      updatedPlans.map((plan, index) => (
      <Card
        plan={plan}
        isProductPage={isProductPage}
        selectedPlan={selectedPlan}
        togglePopUp={togglePopUp}
        planIndex={index}
        key={index}
      />
    ));

  return (
    <React.Fragment>
      {popUpDetail.popUpType && SELECT_POP_UP === popUpDetail.popUpType && (
        <SelectPlan
          toggleSelectPopUp={togglePopUp}
          plan={popUpDetail.plan}
          choosePlan={choosePlan}
          existingPlanPeriod={
            selectedPlan && selectedPlan.choosedARP
              ? selectedPlan.choosedARP
              : DEFAULT_1_MONTH_PLAN
          }
        />
      )}
      {popUpDetail.popUpType && KNOW_MORE_POP_UP === popUpDetail.popUpType && (
        <KnowMore toggleSelectPopUp={togglePopUp} plan={popUpDetail.plan} />
      )}
      <main className={'overflowstop'}>
        <section className="choose-plan-section">
          <div className="container">
            <div className="wrapper">
              {!isProductPage && (
                <div className="info-text">
                  Select from the available plans to enjoy benefits and
                  discounts.
                </div>
              )}
              <div className="carousel-control">
                {
                  <Carousel
                    draggable={false}
                    swipeable={true}
                    showDots={true}
                    responsive={CAROUSEL_RESPONSIVE_CONSTANTS}
                    ssr={true} // means to render carousel on server-side.
                    infinite={false}
                    autoPlay={false}
                    autoPlaySpeed={0}
                    keyBoardControl={true}
                    customTransition={false}
                    transitionDuration={0}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile", ""]}
                    deviceType="desktop"
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                    partialVisible={true}
                  >
                    {renderCards()}
                  </Carousel>
                }
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
};

export default Plan;
